import {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import associateServices from "../../services";
import Loading from "../../components/loading";
import store from "../../reducers/createReducers";
import GLOBAL_ACTIONS from "../../actions/global-actions";
import {useNavigate, useSearchParams} from "react-router-dom";
import stringHelper from "../../helpers/string-helper";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import InformationToast from "../../components/toast/InformationToast";

const Trade = () => {
    const {authenticated} = useSelector(state => state.authenticationReducer)
    const {selectedWallet} = useSelector(state => state.authenticationReducer)
    const {agent} = useSelector(state => state.globalReducer)
    const [loading, setLoading] = useState(true)
    const [url, setUrl] = useState('')

    useEffect(() => {


        if (authenticated) {
            setLoading(true)
            const value = {
                code: selectedWallet?.code,
                currency: 'USD'
            }
            associateServices.playPoker(value).then(res => {
                if (res?.status === 200) {


                    if (agent?.isMobile)
                        window.open(res?.data)
                    else
                        setUrl(res?.data)

                    setLoading(false)
                } else {
                    toast(<InformationToast
                        icon={'ti-error-404'}
                        title={t('general.information')}
                        message={t(`api-notifications.${res?.errors}`, res?.errors)}
                    />)
                    return navigate(stringHelper.getLocalizedPath(currentLanguage, '/'))
                }
            })
        } else {

            navigate(stringHelper.getLocalizedPath(currentLanguage, `/?modal=register`))
        }

    }, [authenticated, selectedWallet?.code])
    const {t, i18n} = useTranslation()
    const currentLanguage = i18n.language; // Get

    const navigate = useNavigate()
    // const {i18n} = useTranslation();
    // const currentLanguage = i18n.language; // Get the current language


    useEffect(() => {
        store.dispatch(GLOBAL_ACTIONS.setSelectedCurrency('USD'))

        if (!authenticated) {
            // to={stringHelper.getLocalizedPath(currentLanguage, `/casino/games/${stat?.game?.slug}`)}

            navigate(stringHelper.getLocalizedPath(currentLanguage, `/?modal=register`))
        } else {


            const mainElement = document.getElementById('main')
            const headerElement = document.getElementById('header')
            const sidebarElement = document.getElementById('sidebar')
            const footerElement = document.getElementById('footer')
            mainElement?.classList?.add('main--sport')
            headerElement?.classList?.add('header--sport')
            if (!agent?.isMobile)
                sidebarElement?.classList?.add('active')
            footerElement?.classList?.add('footer--sport')
            return () => {
                mainElement?.classList?.remove('main--sport')
                headerElement?.classList?.remove('header--sport')

                if (!agent?.isMobile)
                    sidebarElement?.classList?.remove('active')
                footerElement?.classList?.remove('footer--sport')

            }
        }
    }, [authenticated])


    return (
        <div className="section  pt-0">
            <div className="row">
                <div className="col-12">
                    <div className="frame frame--full">
                        <div className="frame__cover">
                            {
                                loading ? <Loading/> :
                                    <iframe
                                        src={url}
                                        id="game"
                                        frameBorder={0}
                                        allowFullScreen
                                        width={'100%'}
                                        height={'100%'}
                                        scrolling={'yes'}
                                    />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )


}

export default Trade
